/**
 * Runs `run` unless a run of it is still in progress or ended less than
 * `quietPeriodMs` ago; the calls in between are dropped, not deferred. The
 * period counts from the end of a run, so a call the run itself causes (the
 * read that follows the end of the sync it started) never starts another
 * one, however long the run took. A rejected run counts as ended; its error
 * is swallowed, so `run` handles and reports its own failures.
 */
export function runUnlessRunningOrRecentlyEnded(
  run: () => Promise<void>,
  quietPeriodMs: number,
  now: () => number = Date.now
): () => void {
  let isRunning = false;
  let lastEndedAt: number | undefined;

  const hasEndedRecently = (): boolean =>
    lastEndedAt !== undefined && now() - lastEndedAt < quietPeriodMs;

  return (): void => {
    if (isRunning || hasEndedRecently()) {
      return;
    }
    isRunning = true;
    void run()
      .finally(() => {
        isRunning = false;
        lastEndedAt = now();
      })
      .catch(() => undefined);
  };
}
